import { GoalType } from "@teaming/common-enums";

export const NO_ID = "";
export const AGGREGATE_ID = "";

export const NO_TEAM = {
	id: NO_ID,
	type: "",
};

export const NO_GOAL = {
	id: NO_ID,
};

export const placeholderGoals = howMany => Array( howMany ).fill( 0 ).map( _ => ( {
	...NO_GOAL,
} ) );

const SKELETON_COUNT = 5;

export const skeletonPage = () => placeholderGoals( SKELETON_COUNT );

// eslint-disable-next-line no-unused-vars
export const pristineState = i18n => ( {
	myTeams: [],
	teamGoalCounts: {
		[ AGGREGATE_ID ]: {
			[ GoalType.ACTIVE ]: -1,
			[ GoalType.ARCHIVED ]: -1,
			[ GoalType.DRAFT ]: -1,
		},
	},
	selectedTeamId: NO_ID,
	selectedGoalType: GoalType.ACTIVE,
	goalPages: [
		skeletonPage(),
	],
	selectedGoal: NO_GOAL,
	pagingOffset: 0,
	pagingLimit: 10,
	isPaging: true,
	hasPaged: false,
	currentPageNumber: 0,
	totalPageCount: 0,
} );
